// Ported from design/project/App02-HowItWorks.dc.html by design/preview/to_tsx.py. Change the design first, then this.
// The fee shown is the live one from the server's Game rules.
import { pct, rules } from "@degenduel/shared";

export function App02_HowItWorks() {
  return (
    <>
      <div className="screen dots">
  <div className="pad squeeze" style={{ height: "100%", paddingBottom: "32px" }}>
    <div className="row">
      <span className="tag tagW">HOW TO PLAY</span>
      <a href="#/App03" className="unb muted" style={{ fontWeight: "700", fontSize: "11px", textDecoration: "none", letterSpacing: "0.08em" }}>SKIP</a>
    </div>

    <div style={{ marginTop: "26px" }} className="banner"><span>3 MOVES. 1 WINNER.</span></div>

    <div style={{ marginTop: "26px", display: "flex", flexDirection: "column", gap: "14px" }}>
      <div className="panel" style={{ display: "flex", gap: "14px", padding: "16px", borderColor: "#CCFF00", boxShadow: "5px 5px 0 #CCFF00" }}>
        <div className="unb" style={{ width: "48px", height: "48px", flex: "none", borderRadius: "12px", background: "#CCFF00", color: "#0B0E14", border: "2px solid #0B0E14", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "900", fontSize: "20px" }}>1</div>
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <span className="unb" style={{ fontWeight: "900", fontSize: "15px" }}>CALL YOUR SIDE</span>
          <span className="muted" style={{ fontSize: "13px", lineHeight: "19px" }}>Pick an asset and a stake, then go LONG if you think price rises or SHORT if it drops.</span>
        </div>
      </div>
      <div className="panel" style={{ display: "flex", gap: "14px", padding: "16px" }}>
        <div className="unb" style={{ width: "48px", height: "48px", flex: "none", borderRadius: "12px", background: "#FFFFFF", color: "#0B0E14", border: "2px solid #0B0E14", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "900", fontSize: "20px" }}>2</div>
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <span className="unb" style={{ fontWeight: "900", fontSize: "15px" }}>BATTLE 1 OR 3 MINUTES</span>
          <span className="muted" style={{ fontSize: "13px", lineHeight: "19px" }}>You face one real opponent on the other side. Both stakes lock from your battle balance, no signing and no gas.</span>
        </div>
      </div>
      <div className="panel" style={{ display: "flex", gap: "14px", padding: "16px" }}>
        <div className="unb" style={{ width: "48px", height: "48px", flex: "none", borderRadius: "12px", background: "#FF3366", color: "#0B0E14", border: "2px solid #0B0E14", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "900", fontSize: "20px" }}>3</div>
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <span className="unb" style={{ fontWeight: "900", fontSize: "15px" }}>WINNER TAKES IT</span>
          <span className="muted" style={{ fontSize: "13px", lineHeight: "19px" }}>The oracle reads the final price. The right call gets the victory payout, minus a {pct(rules().feeBps)} fee.</span>
        </div>
      </div>
    </div>

    <div style={{ marginTop: "22px", display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: "8px" }}>
      <div className="panel" style={{ padding: "10px", textAlign: "center" }}><div className="mono lime" style={{ fontWeight: "800", fontSize: "16px" }}>{pct(rules().feeBps)}</div><div className="muted" style={{ fontSize: "10px", marginTop: "2px" }}>fee on the pot</div></div>
      <div className="panel" style={{ padding: "10px", textAlign: "center" }}><div className="mono" style={{ fontWeight: "800", fontSize: "16px" }}>2 to 1K</div><div className="muted" style={{ fontSize: "10px", marginTop: "2px" }}>USDT per battle</div></div>
      <div className="panel" style={{ padding: "10px", textAlign: "center" }}><div className="mono" style={{ fontWeight: "800", fontSize: "16px" }}>1 or 3</div><div className="muted" style={{ fontSize: "10px", marginTop: "2px" }}>minutes a battle</div></div>
    </div>

    <div style={{ marginTop: "auto", display: "flex", flexDirection: "column", gap: "18px" }}>
      <div style={{ display: "flex", justifyContent: "center", gap: "8px" }} aria-label="Step 1 of 3">
        <span style={{ width: "26px", height: "8px", borderRadius: "4px", background: "#CCFF00" }}></span>
        <span style={{ width: "8px", height: "8px", borderRadius: "4px", background: "#30363D" }}></span>
        <span style={{ width: "8px", height: "8px", borderRadius: "4px", background: "#30363D" }}></span>
      </div>
      <a href="#/App03" className="btnA">GOT IT, LET'S GO</a>
    </div>
  </div>
</div>
    </>
  );
}
